// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { yearsToQuarters as fn } from "../yearsToQuarters.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const yearsToQuarters = convertToFP(fn, 1);

// Fallback for modularized imports:
export default yearsToQuarters;
